<template>
  <div>
    <div class="row">
      <div class="col-6">
        <i class="ml-2 bi bi-question-circle-fill" data-toogle="tooltip" title="This plot has a zoom and an on hover functionalities, that display value of relative abundance."
           v-bind:style="{ fontSize : '15px'}" v-b-tooltip.hover ></i>
      </div>
      <div class="col-6" v-bind:style="{ width:'100%', textAlign: 'right', paddingRight:'20px' }">
        <i class=" mr-1 bi bi-sliders" data-toogle="tooltip" title="Settings" v-b-modal="componentId+'-modal'"
           v-bind:style="{ fontSize : '15px'}"></i>
        <i class=" mr-1 bi bi-card-text" data-toogle="tooltip" title="Legend" v-bind:style="{fontSize : '15px'}" v-b-modal="componentId+'-legend'"></i>
        <i class="mr-1 bi bi-save-fill" data-toogle="tooltip" title="Export" v-bind:style="{ fontSize : '12px'}"
           v-b-modal="componentId+'-modal-save'"></i>
        <i class=" mr-1 bi bi-files" data-toogle="tooltip" title="Duplicate" v-on:click="cloneCurrentWidget"
           v-bind:style="{ fontSize : '12px'}"></i>
      </div>
    </div>
    <div class="widget-legend legend">
      <span :id="componentId+'plot_title'">Distribution of relative abundances (%) of {{ taxon }}
        according to {{ parameter.text }} on fraction {{ fraction }} µm </span>
    </div>
    <ScatterPlotWidget :plotData="plotData" :axisLabel="axisLabel" :componentId="componentId" :advanced="advanced">
    </ScatterPlotWidget>
    <div>
      <b-modal :id="componentId+'-modal'" title="Physico-chemical distribution">
        <div class="form-group mt-2" style="font-size: 1.6vmin;">
          <template>
            <b-form-group label="Representation by" v-slot="{ ariaDescribedby }">
              <b-form-radio-group
                  :id="componentId+'radio-group-1'"
                  v-model="representation"
                  :options="representationOptions"
                  :aria-describedby="ariaDescribedby"
                  name="plot-options"
              ></b-form-radio-group>
            </b-form-group>
          </template>
        </div>
        <div class="form-group mt-2" style="font-size: 1.6vmin;">
          <div class="mb-2">
            <div v-if="representation === 'taxon'">
              <b-form-group label="Taxon">
                <select v-model="taxon" class="form-control">
                  <optgroup v-for="(names, group) in taxons" v-bind:key="group" :label="`${group}`">
                    <option v-for="option in names" v-bind:key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </optgroup>
                </select>
              </b-form-group>
            </div>
            <div v-if="representation === 'asv'">
              <b-form-group label="ASV">
                <select v-model="asv" class="form-control" multiple>
                  <optgroup v-for="(names, group) in asvs" v-bind:key="group" :label="`${group}`">
                    <option v-for="option in names" v-bind:key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </optgroup>
                </select>
              </b-form-group>
            </div>
          </div>
          <b-form-group label="Parameter">
            <select v-model="parameter" class="form-control">
              <option v-for="option in parameters" v-bind:key="option.value" :value="option">
                {{ option.text }}
              </option>
            </select>
          </b-form-group>
          <div class="form-group mt-2">
            <b-form-group label="Depth">
              <select v-model="depth" class="form-control">
                <option v-for="option in depthCodes" v-bind:key="option.depth" :value="option.depth">
                  {{ option.depth }}
                </option>
              </select>
            </b-form-group>
          </div>
          <div class="form-group mt-2" style="font-size: 1.6vmin;">
            <template>
              <b-form-group label="Fraction size" v-slot="{ ariaDescribedby }">
                <b-form-radio-group
                    :id="componentId+'radio-group-2'"
                    v-model="fraction"
                    :options="fractions"
                    :aria-describedby="ariaDescribedby"
                    name="fraction-options"
                ></b-form-radio-group>
              </b-form-group>
            </template>
          </div>
          <div>
            <b-form-checkbox
                :id="componentId+'advanced'"
                v-model="advanced"
                name="advanced_splitting"
                value="checked"
                unchecked-value="not_checked"
            >
              Advanced Splitting
            </b-form-checkbox>
          </div>
          <div class="form-group mt-2" style="font-size: 1.6vmin;" v-if="advanced === 'checked'">
            <template>
              <b-form-group label="Splitting : " v-slot="{ ariaDescribedby }">
                <b-form-radio-group
                    :id="componentId+'radio-group-advanced'"
                    v-model="splitBy"
                    :options="advancedSplittingOptions"
                    :aria-describedby="ariaDescribedby"
                    name="split-options"
                ></b-form-radio-group>
              </b-form-group>
            </template>
          </div>
        </div>
      </b-modal>
    </div>
    <b-modal :id="componentId+'-legend'" title="Legend">
      HTML allowed
      <textarea class="col-12" v-model="legend" placeholder="add multiple lines"></textarea>

      <b-button v-b-toggle="'collapse'+ componentId" variant="primary">Show/Hide</b-button>
    </b-modal>


    <ExportDialog :componentId="componentId" :formattedData="formattedData" :plotData="plotData"
                  :exportFileName="exportFileName"
                  :dataset="dataset" :legend="legend"></ExportDialog>
    <div>
      <b-collapse v-model="visible" :id="'collapse'+componentId" class="">
        <b-card>
          <div v-html="legend">
          </div>

        </b-card>
      </b-collapse>
    </div>

  </div>
</template>


<script>
/* eslint-disable vue/no-dupe-keys */
import axios from "axios";
import ScatterPlotWidget from "./ScatterPlotWidget";
import {mapActions} from "vuex";
import {ApiCall} from "../mixins/ApiMixin";
import ExportDialog from "./ExportDialog.vue";


export default {
  name: "ScatterPlot",
  props: ['panelId', 'componentId', 'trigger_value', 'settings'],
  mixins: [ApiCall],
  data() {
    return {
      representationOptions: [],
      representation: null,
      dataset: null,
      advanced: "not_checked",
      splitBy: null,
      advancedSplittingOptions: [
        {text: 'By Depth', value: 'depth'},
        {text: 'By Year', value: 'year'},
        {text: 'By Cluster', value: 'cluster'},
        {text: 'By Station', value: 'station'}

      ],

      rank: null,
      searchPanelTaxon: null,
      depthCodes: {},
      depth: null,

      dateStart: null,
      dateEnd: null,
      formattedData: null,
      taxon: null,
      taxons: {},
      asv: [],
      asvs: {},
      legend: null,

      parameters: [],
      parameter: {},

      fractions: [],
      fraction: null,

      axisLabel: "",
      plotData: null,
      visible: false,
      settingsHash: "",
      exportFileName: "mygod_scatterplot",
      apiCallsInProgress: 0,
      plotName: 'scatter_plot'
    }
  },
  components: {
    ScatterPlotWidget,
    ExportDialog
  },

  created() {
    this.updateContents()
  },

  watch: {

    trigger_value() {
      this.updateContents()
    },

    taxon() {
      this.drawPlot()
    },

    parameter() {
      this.drawPlot()
    },

    fraction() {
      this.drawPlot()
    },
    depth() {
      this.getPlotData()
    },
    asv() {
      this.drawPlot()
    },
    representation() {
      this.getPlotData()
    },
    advanced() {
      if (this.advanced === 'not_checked') {
        this.splitBy = null
      }
    },
    splitBy() {
      this.getPlotData()
    },
    legend() {
      this.updateDashboardWidgetLegend({
        'componentId': this.componentId,
        'legend': this.legend
      })
    },
    plotData() {
      this.reformatData()
    }
  },

  methods: {

    ...mapActions([
      'updateDashboardWidgetSettings',
      'cloneWidget',
      'updateDashboardWidgetLegend'
    ]),

    updateContents() {
      let panel = this.$store.state.panels[this.panelId]

      let newPanelSettingsHash = panel.dataset + panel.rank + panel.taxon + panel.dateStart + panel.dateEnd
      if (newPanelSettingsHash === this.settingsPanelHash) {
        return
      }
      this.settingsPanelHash = newPanelSettingsHash
      this.plotData = null

      this.dataset = panel.dataset
      this.rank = panel.rank
      this.searchPanelTaxon = panel.taxon
      this.dateStart = panel.dateStart
      this.dateEnd = panel.dateEnd

      this.initializeRepresentation()
      this.initializeLegend()
      this.initializeSplitBy()
      this.initializeParameters()
      this.initializeFractionSizes()
      this.initializeDepthCode()
    },

    /*
      Method to be used by all other methods needing to (re)generate the plot.
      For now it only calls get_axisLabel() which cascades to getPlotData().
      But this may change in the future.
      Other methods are not supposed to call get_axisLabel() directly.
     */
    drawPlot() {
      this.getAxisLabel()
    },


    getPlotData() {
      if (this.apiCallsInProgress > 0) {
        setTimeout(this.getPlotData, 2000)
        return
      }
      if (this.dataset && this.fraction && this.parameter.value && this.dateStart && this.dateEnd && this.taxon && this.asv && this.depth && this.representation) {
        let asvString = this.asv
        let newSettingsHash = this.dataset + this.taxon + asvString + this.fraction + this.parameter.value + this.dateStart + this.dateEnd + this.depth + this.representation + this.splitBy

        if (newSettingsHash === this.settingsHash) {
          return
        }

        this.settingsHash = newSettingsHash
        this.plotData = null

        this.updateDashboardWidgetSettings({
          'componentId': this.componentId,
          'settings': {
            'dataset': this.dataset,
            'taxon': this.taxon,
            'asv': this.asv,
            'representation': this.representation,
            'fraction': this.fraction,
            'parameter': this.parameter,
            'dateStart': this.dateStart,
            'dateEnd': this.dateEnd,
            'depth': this.depth,
            'splitBy': this.splitBy,
            'legend': this.legend,
            'advanced': this.advanced
          }
        })

        let me = this

        if (this.representation === "taxon" || this.representation === "count") {
          let taxonSelectValue = this.taxon
          let words = taxonSelectValue.split('@')
          let rank = words[0]
          let taxon = words[1]
          axios
              .get(this.sanitizeApiCall(this.$store.state.apiRootPath,['relative_abundances_taxon',
              this.dataset,rank,taxon,this.fraction,this.parameter['value'],this.dateStart,this.dateEnd,this.depth,this.representation,
              this.splitBy]))
              .then(function (response) {
                me.plotData = response.data
              })
        }
        if (this.representation === "asv") {
          let asv_list = JSON.stringify(this.asv)
          // TODO: Don't forget that a too long GET request (more than 4096) need to be transform to POST.
          axios
              .get(this.sanitizeApiCall(this.$store.state.apiRootPath,['relative_abundances_asv',
              this.dataset,asv_list,this.fraction,this.parameter['value'],this.dateStart,this.dateEnd,this.depth,
              this.splitBy]))
              .then(function (response) {
                me.plotData = response.data
              })
        }
      } else {
        console.debug("getPlotData() " + this.componentId + ": undefined parameters, no actual data  retrieval attempted.")
      }
    },

  }
}


</script>

<style scoped>
.radio-button-font {
  font-size: large;
}

</style>